import { createResource } from '@zocdoc/batch-fetch';

const host = process.env.TIMESLOTS_API_HOST || process.env.API_HOST || '';

const TimeslotsResource = createResource({
    endpoint: `${host}/api/3/professionallocation/timeslots`,
    idAttribute: 'professional_location_ids',
});

export default TimeslotsResource;
